export const ACCOUNTSDESTINATIONS_GET_ACCOUNTSDESTINATIONS = "account-destinations/get-account-destinations";
